import { render, staticRenderFns } from "./UtxoBlock.vue?vue&type=template&id=4cd6f95e&scoped=true&"
import script from "./UtxoBlock.vue?vue&type=script&lang=ts&"
export * from "./UtxoBlock.vue?vue&type=script&lang=ts&"
import style0 from "./UtxoBlock.vue?vue&type=style&index=0&id=4cd6f95e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd6f95e",
  null
  
)

export default component.exports